var heading_default = {
  "fontElementMap": "kyw98",
  "elementSpacing": "CkAwF",
  "headerOne": "aacMr CkAwF",
  "headerTwo": "s-D3z CkAwF",
  "headerThree": "CxyN0 CkAwF",
  "headerFour": "MuDUs CkAwF",
  "headerFive": "jz-cm CkAwF",
  "headerSix": "GouOa CkAwF",
  "child": "rrhuo"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
